import React from "react";
import { Modal, Button } from "react-bootstrap";

const TerminateEmployeeModal = ({
  show = false,
  onClose = () => {},
  confirmDelete = () => {},
  Name = "Delete",
  btnName = "Delete",
  terminationLoading
}) => {
  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Body>
        <div className="form-header text-center">
          <h3>{Name}</h3>
          <p>Are you sure you want to {Name}?</p>
        </div>
        <div className="d-flex justify-content-between mt-4 gap-4">
          <Button variant="danger" onClick={confirmDelete} className="w-100" disabled={terminationLoading? true : false}>
            {btnName}
          </Button>
          <Button variant="secondary" onClick={onClose} className="w-100" disabled={terminationLoading? true : false}>
            Cancel
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default TerminateEmployeeModal;
